import type { WhatsAppConnectionResponse } from "@multi-chat/shared";

export function profilePictureUrlForPhone(
  connection: WhatsAppConnectionResponse,
  externalPhoneNumberId: string,
): string | null {
  const fromList = connection.phoneNumbers.find(
    (phone) => phone.externalPhoneNumberId === externalPhoneNumberId,
  );
  if (fromList?.profilePictureUrl) {
    return fromList.profilePictureUrl;
  }
  if (
    connection.workspacePhone?.externalPhoneNumberId === externalPhoneNumberId &&
    connection.workspacePhone.profilePictureUrl
  ) {
    return connection.workspacePhone.profilePictureUrl;
  }
  return null;
}

/** Patch one Phone Number ID's live profile picture without replacing the connection payload. */
export function withPhoneProfilePicture(
  connection: WhatsAppConnectionResponse,
  externalPhoneNumberId: string,
  profilePictureUrl: string | null,
): WhatsAppConnectionResponse {
  const phoneNumbers = connection.phoneNumbers.map((phone) =>
    phone.externalPhoneNumberId === externalPhoneNumberId
      ? { ...phone, profilePictureUrl }
      : phone,
  );
  const workspacePhone =
    connection.workspacePhone?.externalPhoneNumberId === externalPhoneNumberId
      ? { ...connection.workspacePhone, profilePictureUrl }
      : connection.workspacePhone;
  return { ...connection, phoneNumbers, workspacePhone };
}
